export class ComplexEnumItem<ID extends Lowercase<string> = Lowercase<string>> {
  /**
   * An id which should uniquely identify a complex enum item:
   *
   * - Must be lowercase
   * - Usually a UUID
   *
   * Using lowercased uuid strings aligns with the UUID spec.
   *
   * @see https://datatracker.ietf.org/doc/html/rfc4122#section-3
   */
  readonly id: ID

  constructor(id: ID) {
    this.id = id
  }
}
